var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"protal-richtext-con"},[_c('div',{staticClass:"richtext-wrapper",domProps:{"innerHTML":_vm._s(_vm.richText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }